import React, { PureComponent } from 'react'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { connect } from 'react-redux'
import { nextPoint, isAutoPlayEnabled } from 'aria-viewer/tour/tourActions'

class AutoPlay extends PureComponent {
    autoplay(props, instant) {
        clearTimeout(this.timeout)
        if (!props.loading && props.isAutoPlayEnabled && !props.isAutoPlayBlocked) {
            this.timeout = setTimeout(() => {
                //If we have reached the end of the experience,
                if (props.hasReachedEndOfExperience) {
                    //tell our parent
                    parent && parent.postMessage('data:::end_of_tour_reached', '*')
                    //give the parent a few secnds to respond or we start over.
                    setTimeout(() => {
                        props.nextPoint()
                    }, 2000)
                } else {
                    props.nextPoint()
                }
            }, instant ? 0 : 5000)
        }
    }
    componentDidMount() {
        this.autoplay(this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.autoplay(nextProps, this.props.isAutoPlayBlocked !== nextProps.isAutoPlayBlocked)
    }
    render() {
        const {
            props: { isAutoPlayEnabled, isAutoPlayEnabledAction },
        } = this
        // do not cancel autoplay on user interaction with experience... user should just remove #autoplay
        return <div style={{ display: 'none' }} />
    }
}

export default connect(
    mapSelectorsToProps([
        'isAutoPlayEnabled',
        'isAutoPlayBlocked',
        'hasReachedEndOfExperience',
        'mainMedia',
        'loading',
    ]),
    {
        nextPoint,
        isAutoPlayEnabledAction: isAutoPlayEnabled,
    }
)(AutoPlay)
